//Components
import { ReleaseNotesContainer } from "components/ReleaseNotesContainer";

const ReleaseNotePage = () => {
  return <ReleaseNotesContainer />;
};
export default ReleaseNotePage;
